import * as Sentry from '@sentry/vue'

const initActionLog = (store) => {
  // Subscribe action hooks
  try {
    if (store.subscribeAction) {
      store.subscribeAction({
        error: (action, state, error) => {
          Sentry.captureException(new Error(`Error in vuex action: ${action.type}`), {
            extra: {
              error,
              action, // log full data action params, type, ...
            },
          })
        },
      })
    }
  } catch (error) {
    // do nothing
  }
}

export default {
  initActionLog,
}
